import { useEffect, useRef } from "react";
import { FormattedMessage as FM } from "react-intl";

import HeaderCell from "./HeaderCell";
import { icons } from "./icons";
import { cn } from "tools/ui";

function TableHeader(props) {
  const { layout, parentRec, selectRows, access, allSelected, someSelected } =
    props;
  const headerCheckboxRef = useRef(null);

  useEffect(() => {
    if (headerCheckboxRef.current) {
      headerCheckboxRef.current.indeterminate = someSelected;
    }
  }, [someSelected]);

  const cellButtonStart = [];
  const cellButtonEnd = [];
  if (layout.table_action) {
    for (const btn of layout.table_action) {
      if (btn === "add" || btn === "date-card") {
        continue;
      }
      if (btn === "edit" || btn === "open") {
        cellButtonStart.push(btn);
      } else if (btn === "delete") {
        const accessDelete = access?.delete
          ? access.delete(parentRec.record)
          : true;
        if (accessDelete) cellButtonEnd.push(btn);
      } else {
        cellButtonEnd.push(btn);
      }
    }
  }

  function cellButtons(buttons) {
    const [IconEdit, color] = icons.edit;
    return buttons.map((button) => {
      if (button === "edit" || button === "open") {
        return (
          <th key={button} className="px-2">
            <IconEdit
              className={cn("h-4 w-4 fill-current", color)}
              aria-hidden="true"
            />
          </th>
        );
      } else {
        return (
          <th key={button} className="px-2">
            <FM id={`button_${button}`} />
          </th>
        );
      }
    });
  }

  function handleCheck(e) {
    if (selectRows) selectRows(e.target.checked);
  }

  function headers() {
    const headers = [];
    const listFields = layout?.list || [];
    for (const field of listFields) {
      if (field.invisible) continue;
      headers.push(
        <HeaderCell
          key={field.name}
          index={field.name}
          field={field}
          {...props}
        />,
      );
    }
    return headers;
  }

  return (
    <thead className="sticky top-0 leading-6">
      <tr className="bg-amber-100">
        {layout.selectable === "multi" && (
          <th className="text-center w-10">
            <input
              ref={headerCheckboxRef}
              type="checkbox"
              name={"selectable_header"}
              onChange={handleCheck}
              checked={allSelected}
              className="h-4 w-4 rounded-lg accent-sky-600"
            />
          </th>
        )}
        {cellButtons(cellButtonStart)}
        {headers()}
        {cellButtons(cellButtonEnd)}
      </tr>
    </thead>
  );
}

export default TableHeader;
